import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Link, NavLink } from 'react-router-dom';
import Notification from '../notification/notification';
import { analyticsClickEvent } from '../../action/firebaseAnalytics/firebaseAnalytics';
import { manualLogout } from '../../action/auth/logout';
import Cookies from 'universal-cookie';
import { PropTypes } from 'prop-types';
import withRouter from '../../withRouter';
import AnnouncementBanner from './AnnouncementBanner';

export class Header extends React.Component {
    constructor(props) {

        super(props);
        this.state = {
            profilePicture: props.profilePicture,
            totalNotification: 0,
            isHaveNotification: 0,
            clicked: false,
            notifyFunction: this.handleNotificationFunctionalities.bind(this),
            locationValue: '',
            totalNotifications: true,
            isdropdownmenushow: false,
            showHeader:true,
            isBrokerTakenApplication:false,
            UserName : ''
        }
        this.notificationCall = React.createRef();
        this.headerRef = React.createRef();
        this.resizeObserver = null;
        this.navbarMenuRef = React.createRef();
        this.navbarTogglerRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('click', this.handleDropdownClick);
        document.addEventListener('touchstart', this.handleDropdownClick);

        let broker = window.location.search.includes('broker');    
        if (broker) {
            this.setState({isBrokerTakenApplication:true})
        }
        if(localStorage.getItem('fromWhere') == 'apply_now' || sessionStorage.getItem('fromWhere') == 'apply_now'){
           this.setState({showHeader:false});
        }
        if (this.headerRef.current) {
            this.resizeObserver = new ResizeObserver((entries) => {
                for (let entry of entries) {
                    let height = entry.target.offsetHeight;
                    if (entry.borderBoxSize) {
                        const borderBox = Array.isArray(entry.borderBoxSize)
                            ? entry.borderBoxSize[0]
                            : entry.borderBoxSize;

                        if (borderBox?.blockSize) {
                            height = borderBox.blockSize;
                        }
                    }

                    document.documentElement.style.setProperty('--header-height', `${height}px`);
                }
            });

            this.resizeObserver.observe(this.headerRef.current);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.userName !== this.props.userName) {
            if (this.props.userName) {
                this.setState({
                    UserName: this.props.userName
                });
            }
        }
        if (sessionStorage.getItem('actor')) {
            document.body.classList.add('actor-login');
        }
    }

    handleClickOutside = (event) => {
        setTimeout(() => {
            this.setState({ clicked: false })
        }, 100);
    }

    closeDropdownMenu = () => {
        const MenuElement = this.navbarMenuRef.current;
        const togglerElement = this.navbarTogglerRef.current;
        if (MenuElement && togglerElement && MenuElement.classList.contains('show')) {
            MenuElement.classList.remove('show');
            togglerElement.setAttribute('aria-expanded', 'false');
        }
    }

    handleDropdownClick = (event) => {
        const MenuElement = this.navbarMenuRef.current;
        const togglerElement = this.navbarTogglerRef.current;
        if (!MenuElement || !togglerElement) {
            return;
        }

        const isMenuOpen = MenuElement.classList.contains('show');
        if (!isMenuOpen) {
            return;
        }

        if (MenuElement.contains(event.target) || togglerElement.contains(event.target)) {
            return;
        }
        setTimeout(() => {
            MenuElement.classList.remove('show');
            togglerElement.setAttribute('aria-expanded', 'false');
        }, 300);
    }

    handleNotificationFunctionalities = () => {
        if (localStorage.getItem('fromWhere') != 'skip') {
            if (this.notificationCall?.current) {
                this.notificationCall.current.initialLoad();
            }
        }
    }

    componentWillUnmount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        document.body.removeEventListener('click', this.opendropdown);
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
        document.documentElement.style.removeProperty('--header-height');
        document.removeEventListener('click', this.handleDropdownClick);
        document.removeEventListener('touchstart', this.handleDropdownClick);
        document.body.classList.remove('actor-login');
    }


    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.location.pathname != prevState.locationValue) {
            return {
                locationValue: nextProps.location.pathname,
                model: prevState.notifyFunction(nextProps.model)
            }
        }
        if (prevState.profilePicture !== nextProps.profilePicture) {
            return {
                profilePicture: nextProps.profilePicture
            };
        }
        return null;
    }

    totalNotification = (data, isHaveNotif) => {
        this.setState({ totalNotification: data, isHaveNotification: isHaveNotif })
    }
    totalNotificationCount = () => {
        analyticsClickEvent('notifications','')
        // this.setState({ totalNotifications: false})
    }

    notCloseNotification = (e) => {
        // console.log(this.state.clicked);
        // setTimeout(() => {
        //     this.setState({clicked:true,isdropdownmenushow:true})
        //     console.log(this.state.clicked +" - "+ this.state.isdropdownmenushow);
        // }, 0);
        // e.preventDefault();
        // e.stopPropagation()
    }

    opendropdown = (event) => {
        this.setState({ clicked: false })
        analyticsClickEvent('notifications','')
        if (localStorage.getItem('fromWhere') != 'skip') {
            setTimeout(() => {
                this.setState({ clicked: true })
            }, 100);
        }
        event.preventDefault();
    }

    onBlurEvent = (event) => {
        console.log(event);
        if (localStorage.getItem('fromWhere') != 'skip') {



            setTimeout(() => {
                this.setState({ clicked: false, isdropdownmenushow: false })
            }, 500);
        }
    }

    headerClickEvent = (data) => {
        analyticsClickEvent(data,'')
    }

    handleAuth = async (event) => {    // 'login' clear and send to login page ''skip'' ''normal users'' 
        const actor = sessionStorage.getItem("actor");
		if (actor) {
            event.preventDefault();
			sessionStorage.removeItem("actor");
            sessionStorage.removeItem("adminUserView");
            sessionStorage.removeItem("actor_email");
			window.location.href = '/admin-dashboard';
			return;
		}
        analyticsClickEvent('logout','')
        const cookie = new Cookies();
    
        let results = await manualLogout()
        if (results.status == 200) {
            localStorage.clear();
            sessionStorage.clear();
            this.props.unsetProfilePic(); window.location.reload(); this.props.unsetContractSummary('');
            
            // Remove cookie for Retailer Id once the user has logout of the application
            cookie.remove('retailerId', { path: '/' });
            cookie.remove('loanAmount', { path: '/' });
            cookie.remove('term', { path: '/' });
            cookie.remove('firstName', { path: '/' });
            cookie.remove('lastName', { path: '/' });
            cookie.remove('email', { path: '/' });
            cookie.remove('sourceURL', { path: '/' });
            cookie.remove('mobileNumber', { path: '/' });
            cookie.remove('approvedURL', { path: '/' });
            cookie.remove('retailerReference', { path: '/' });
            cookie.remove('Dob', { path: '/' });
            cookie.remove('flatAbode', { path: '/' });
            cookie.remove('houseandBuildingName', { path: '/' });
            cookie.remove('houseandBuildingNumber', { path: '/' });
            cookie.remove('numberAndStreet', { path: '/' });
            cookie.remove('addressLine2', { path: '/' });
            cookie.remove('townOrCity', { path: '/' });
            cookie.remove('postcode', { path: '/' });
            
        }else{
            localStorage.clear();
            sessionStorage.clear();
            this.props.unsetProfilePic(); window.location.reload(); this.props.unsetContractSummary('');
            cookie.remove('retailerId', { path: '/' });
            cookie.remove('loanAmount', { path: '/' });
            cookie.remove('term', { path: '/' });
            cookie.remove('firstName', { path: '/' });
            cookie.remove('lastName', { path: '/' });
            cookie.remove('email', { path: '/' });
            cookie.remove('mobileNumber', { path: '/' });
            cookie.remove('sourceURL', { path: '/' });
            cookie.remove('approvedURL', { path: '/' });
            cookie.remove('retailerReference', { path: '/' });
            cookie.remove('Dob', { path: '/' });
            cookie.remove('numberAndStreet', { path: '/' });
            cookie.remove('addressLine2', { path: '/' });
            cookie.remove('townOrCity', { path: '/' });
            cookie.remove('postcode', { path: '/' });
        }

    }

    analyticsevent = (e) => {
        analyticsClickEvent('settings_menu','')
    }

    analyticsclickEventForHomeMenu = () => {
        analyticsClickEvent('home_menu','')
    }

    analyticsclickEventForWalletMenu = (event) => {
        if (localStorage.getItem('fromWhere') === 'skip') 
        { 
            event.preventDefault(); 
        }  
        analyticsClickEvent('wallet_menu','')
    }

    analyticsclickEventForShopMenu = () => {
        sessionStorage.setItem('showCategories', 'true'); 
        analyticsClickEvent('shop_menu','')
    }

    analyticsclickEventForApplyMenu = (e) => {
        const cookie = new Cookies();
        analyticsClickEvent('apply_menu','')
        const currentPath=window.location.pathname;
        const hasMitekToken=window.location.search.includes('mitek_token');
        const resetOrigin=sessionStorage.getItem('resetMitekOrigin');
        const blockApplynowHeader=currentPath.includes('/application') && (hasMitekToken || resetOrigin==='mitek' || resetOrigin==='ob-landing');
        if(blockApplynowHeader){
            e.preventDefault();
        }

        if(sessionStorage.getItem('RetailerIdFromQuoteTool')) {
            cookie.set('retailerId', sessionStorage.getItem('RetailerIdFromQuoteTool'),{ path: '/' });
            // Reset the value of RetailerIdFromQuoteTool after saving it to cookie "retailerId"
            sessionStorage.removeItem('RetailerIdFromQuoteTool');
            sessionStorage.removeItem('quote-loan-amount');
            sessionStorage.removeItem('quote-loan-term');
        }
    }


    analyticsclickEventForMyAccount = (event) => {
        analyticsClickEvent('my_account',''); 
        if(localStorage.getItem('fromWhere') === 'skip'){ 
            event.preventDefault(); 
        }
    }

    activePathForShop = () => {
        return ['/shop', '/favorite-partner', '/viewed-partner'].includes(window.location.pathname);
    }

    loginClickForSkippedUser = () => {
        localStorage.clear();
        sessionStorage.clear();
        this.props.unsetProfilePic(); window.location.reload(); 
        this.props.unsetContractSummary('');
        analyticsClickEvent('login','')
    }

    render() {
        let validSession = (localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now') ? sessionStorage.getItem('token') !== null : localStorage.getItem('token') !== null;
        const isActorLogin = !!sessionStorage.getItem('actor');
        let userName = this.props.userName || sessionStorage.getItem('UserName') || '';
        return (

            <header ref={this.headerRef} className='fixed-top d-flex flex-column '>
              { isActorLogin && <div className='admin-user-banner'>You are logged in as a {userName}</div>}
              <nav className={`navbar navbar-expand-lg navbar-light bg-light d-flex flex-column  ${isActorLogin ? "actor-navbar" : ""}`}>
                <div className=" container custom-container-sec">
                    {this.state.showHeader===true &&
                    <Link to="/home" className="navbar-brand">
                        <img src="images/logo.svg" alt="Humm" />
                    </Link>
                    }
                    {this.state.showHeader===false &&
                    <span className="navbar-brand">
                        <img src="images/logo.svg" alt="Humm" />
                        </span>
                    }

                    
                    {(localStorage.getItem('fromWhere') != 'apply_now' && sessionStorage.getItem('fromWhere') != 'apply_now') &&<button ref={this.navbarTogglerRef} className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>}
                    <div ref={this.navbarMenuRef} className="collapse navbar-collapse" id="navbarNavDropdown">
                        <ul className="navbar-nav mr-auto">
                            {this.state.showHeader===true &&
                                <li className="nav-item">
                                <NavLink to="/home" className="nav-link" activeClassName="active" 
                                onClick={() => {
                                    this.analyticsclickEventForHomeMenu();
                                    const navbar = document.querySelector('.navbar');
                                    if (navbar) {
                                        navbar.style.right = '0px';
                                    }
                                    this.closeDropdownMenu();
                                }}>Home</NavLink>
                              </li>
                            }
                            {(localStorage.getItem('fromWhere') != 'apply_now' && sessionStorage.getItem('fromWhere') != 'apply_now') && this.state.showHeader === true &&
                              <li className="nav-item">
                                <NavLink to="/wallet" className="nav-link" 
                                onClick={() => {
                                    this.analyticsclickEventForWalletMenu();
                                    const navbar = document.querySelector('.navbar');
                                    if (navbar) {
                                        navbar.style.right = '0px';
                                    }
                                    this.closeDropdownMenu();
                                }} 
                                activeClassName="active">Wallet</NavLink>
                              </li>
                              }
                              {this.state.showHeader===true &&
                                <li className="nav-item">
                                    <NavLink to='/shop' id='shop' 
                                    onClick={() => {
                                        this.analyticsclickEventForShopMenu();
                                        const navbar = document.querySelector('.navbar');
                                        if (navbar) {
                                            navbar.style.right = '0px';
                                        }
                                        this.closeDropdownMenu();
                                    }}
                                    className="nav-link" activeClassName="active"
                                    isActive={this.activePathForShop} >
                                    Shop</NavLink>
                                </li>
                              }
                          
                            
                          {this.state.showHeader===true &&
                            <li className="nav-item">
                            <NavLink to="/application" className="nav-link" activeClassName="active" onClick={(e)=>{ this.analyticsclickEventForApplyMenu(e); this.closeDropdownMenu(); }}      >Apply Now</NavLink>
                            {/* <NavLink to="/application"  onClick={()=>{setTimeout(() => {window.location.reload() },1000)}} className="nav-link" activeClassName="active">Apply Now</NavLink> */}
                            </li>
                          }


                        {/* {this.state.showHeader===true &&
                            <li className="nav-item">
                            <NavLink to="/application" className="nav-link"
                                onClick={() => {
                                    this.analyticsclickEventForQuoteMenu();
                                    const navbar = document.querySelector('.navbar');
                                    if (navbar) {
                                        navbar.style.right = '0px';
                                    }
                                }}
                                activeClassName="active"
                                isActive={this.activePathForQuote}
                                >Quote</NavLink>
                            </li>
                        } */}

                        {/* {this.state.showHeader===false && this.state.isBrokerTakenApplication === false &&
                            <li className="nav-item">
                             <NavLink to="/application" className="nav-link"
                                onClick={() => {
                                    this.analyticsclickEventForQuoteMenu();
                                    const navbar = document.querySelector('.navbar');
                                    if (navbar) {
                                        navbar.style.right = '0px';
                                    }
                                }}
                                activeClassName="active"
                                isActive={this.activePathForQuote}
                                >Quote</NavLink>
                            </li>
                        }                         */}
                          
                            
                        </ul>

                        {this.state.showHeader===true &&    
                        <div className="user-panel d-flex">
                            <div className={this.state.clicked ? "dropdown notification-btn show" : "dropdown notification-btn"} onBlur={(e) => { this.onBlurEvent(e) }}>
                                {(localStorage.getItem('fromWhere') != 'apply_now' && sessionStorage.getItem('fromWhere') != 'apply_now') &&
                            <button className="btn btn-secondary btn-style" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  onClick={(event)=>{event.preventDefault();this.totalNotificationCount()}}  style={this.state.totalNotification === 0 ? { paddingRight: 20 } : {}}>
                                    <img src="images/bell.svg" alt="notification" />
                                    {this.state.totalNotification !== 0 && (
                                    <span className="badge badge-light text-center">
                                    {this.state.totalNotification}
                                    </span>)}
                                    <span className="sr-only">unread messages</span>
                                </button>
                                }
                                {(localStorage.getItem('fromWhere') != 'apply_now' && sessionStorage.getItem('fromWhere') != 'apply_now') &&
                                    <div className={this.state.clicked ? "dropdown-menu show" : "dropdown-menu"} aria-labelledby="dropdownMenuLink" id="dropdown-menu" onKeyDown={(e) => { e.preventDefault(); }} onClick={(e) => { e.stopPropagation(); }} onBlur={(e) => {this.onBlurEvent(e)}}>
                                        {this.state.isHaveNotification == 0 &&
                                            <h6 className="section-main-title text-center">No notifications</h6>
                                        }
                                        { (validSession)  &&
                                            <Notification totalNotification={this.totalNotification} notificationLabelchange={this.openNotificationCountLabel} notCloseNotification={this.notCloseNotification} ref={this.notificationCall} />
                                        }
                                    </div>
                                }
                            </div>
                            {this.state.profilePicture !== '' && this.state.profilePicture !== null &&
                                <div className="image">
                                    <img src={this.state.profilePicture} className="img-circle elevation-2" alt="User avatar" />
                                </div>
                            }
                            {this.state.profilePicture === null &&
                                <div className="image">
                                    <div className="no-profile-image">
                                        {(userName!=='' && userName!==null) &&
                                            <span className="no-profile-image-letter">{userName.charAt(0).toUpperCase()}</span>
                                        }
                                    </div>
                                </div>
                            }



                            <div className="nav-item dropdown" >
                                <button className="nav-link pr-0 btn-style" id="navbarDropdown" tabIndex="0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  onClick={(e) =>{ e.preventDefault();this.analyticsevent(e)}} style={{ backgroundColor: 'transparent' }}>
                                    <div className="info">
                                        {userName !== '' && userName !== null &&
                                            <span><span className="header-user-name">{userName}</span>
                                                <img src="images/down-arrow.svg" alt="down arrow" className="down-arrow-show" />
                                                <img src="images/up-arrow.svg" alt="up arrow" className="up-arrow-show" />
                                            </span>
                                        }
                                        {userName === null &&
                                            <span>
                                                <img src="images/down-arrow.svg" alt="down arrow" className="down-arrow-show" />
                                                <img src="images/up-arrow.svg" alt="up arrow" className="up-arrow-show" />
                                            </span>
                                        }
                                    </div>
                                </button>
                                <div className={ (localStorage.getItem('fromWhere') !== 'apply_now' && sessionStorage.getItem('fromWhere') !== 'apply_now') ? `dropdown-menu user-options-dropdown` : `dropdown-menu user-options-dropdown skip-for-now-option`} aria-labelledby="navbarDropdown">
                                    <ul>
                                    {(localStorage.getItem('fromWhere') != 'apply_now' && sessionStorage.getItem('fromWhere') != 'apply_now') &&
                                        <li>

                                            <Link to="/my-account" onClick={() => {
                                                this.analyticsclickEventForMyAccount();
                                                this.closeDropdownMenu();
                                                const navbar = document.querySelector('.navbar');
                                                if (navbar) {
                                                    navbar.style.right = '0px';
                                                }}}>   
                                                <span>
                                                <img src="images/account.svg" className="default" alt="my account" />
                                                <img src="images/accountActive.svg" className="active" alt="my account" />
                                            </span>
                                             {' '}My Account </Link>

                                        </li>
                                     }
                                     {(localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now') &&
                                        <li>

                                            <a href={process.env.REACT_APP_URL}>   <span>
                                                <img src="images/account.svg" className="default" alt="my account" />
                                                <img src="images/accountActive.svg" className="active" alt="my account" />
                                            </span>
                                            {' '}My Account </a>

                                        </li>
                                     }
                                     {(localStorage.getItem('fromWhere') != 'apply_now' && sessionStorage.getItem('fromWhere') != 'apply_now') &&
                                        <li >
                                            <button id="notification" className='btn-style' type='button' onClick={(e) => {this.opendropdown(e); }} style={{ backgroundColor: 'transparent' }} >
                                                <span>
                                                    <img src="images/notification.svg" className="default" alt="notification" />
                                                    <img src="images/notificationActive.svg" className="active" alt="notification" />
                                                </span>
                                                Notifications   {this.state.totalNotification !== 0 && (
                                                <span className="badge badge-light text-center">
                                                {this.state.totalNotification}
                                                </span>)}</button>
                                        </li>
                                    }
                                        <li>
                                            <a href="https://www.shophumm.com/uk/faqs/" target="_blank" rel="noreferrer" onClick={(e) => {this.headerClickEvent('help_center');this.closeDropdownMenu()}} >
                                                <span>
                                                    <img src="images/help.svg" className="default" alt="help" />
                                                    <img src="images/helpActive.svg" className="active" alt="help" />
                                                </span>
                                              {' '}Help Center/Contact </a>
                                        </li>
                                        <li>
                                            <a href="https://www.shophumm.com/uk/privacy-policy/" target="_blank" rel="noreferrer" onClick={(e) => {this.headerClickEvent('privacy_policy');this.closeDropdownMenu()}} >
                                                    <span>
                                                        <img src="images/privacy.svg" className="default" alt="privacy" />
                                                        <img src="images/privacyActive.svg" className="active" alt="" aria-hidden="true" />
                                                    </span>
                                              {' '}Privacy Policy </a>
                                        </li>
                                        <li>
                                            <a href="https://www.shophumm.com/uk/important-information" target="_blank" rel="noreferrer" onClick={(e) => {this.headerClickEvent('terms_conditions');this.closeDropdownMenu()}}>
                                                <span>
                                                    <img src="images/terms.svg" className="default" alt="terms" />
                                                    <img src="images/termsActive.svg" className="active" alt="terms" />
                                                </span>
                                                {' '}Terms and Conditions </a>
                                        </li>                                        
                                    </ul>
                                        {(localStorage.getItem('fromWhere') !== 'apply_now' && sessionStorage.getItem('fromWhere') !== 'apply_now') &&
                                        <span className="logout-link"><Link to="/login" id='logout-header' onClick={this.handleAuth}>{'Log Out'}</Link></span>}

                                        {(localStorage.getItem('fromWhere') == 'apply_now' || sessionStorage.getItem('fromWhere') == 'apply_now') &&
                                        <span className="logout-link"><Link to="/login" id='logout-header' onClick={this.loginClickForSkippedUser}>{'Log In'}</Link></span>}
                                </div>
                            </div>
                        </div>
                         }
                    </div>
                                   
                </div> 
               </nav>
               <AnnouncementBanner/>
            </header>  
                
        );
    }
}

const mapStateToProps = (state) => {
    return {
        profilePicture: state.dataStore.profilePicture,
        userName:state.dataStore.userName
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        unsetProfilePic: () => {
            return dispatch({
                type: 'UNSET_PROFILE_PIC'
            });
        },
        unsetContractSummary: () => {
            return dispatch({
                type: 'UNSET_CONTRACT_SUMMARY'
            });
        },
        setProfilePic: (userPic) => {
            return dispatch({
                type: 'SET_PROFILE_PIC',
                value: userPic
            });
        }
    }
}

Header.propTypes = {
    profilePicture: PropTypes.string,
    location: PropTypes.object,
    model: PropTypes.string,
    unsetProfilePic: PropTypes.func,
    unsetContractSummary: PropTypes.func,
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Header)

